export const ZODIAC_IDS = [
  'rat',
  'ox',
  'tiger',
  'rabbit',
  'dragon',
  'snake',
  'horse',
  'goat',
  'monkey',
  'rooster',
  'dog',
  'pig',
];

export const ZODIAC_KO = {
  rat: '쥐띠',
  ox: '소띠',
  tiger: '호랑이띠',
  rabbit: '토끼띠',
  dragon: '용띠',
  snake: '뱀띠',
  horse: '말띠',
  goat: '양띠',
  monkey: '원숭이띠',
  rooster: '닭띠',
  dog: '개띠',
  pig: '돼지띠',
};

export const STAR_SIGN_KO = {
  aries: '양자리',
  taurus: '황소자리',
  gemini: '쌍둥이자리',
  cancer: '게자리',
  leo: '사자자리',
  virgo: '처녀자리',
  libra: '천칭자리',
  scorpio: '전갈자리',
  sagittarius: '사수자리',
  capricorn: '염소자리',
  aquarius: '물병자리',
  pisces: '물고기자리',
};

export const ERA_ORDER = ['1970s', '1980s', '1990s', '2000s', '2010s', '2020s'];

/** 12간지 — 양력 연도 기준 (Tier 0: 음력 설 경계 미반영) */
export const getZodiac = (year) => ZODIAC_IDS[(((year - 1984) % 12) + 12) % 12];

/** 별자리 = background_id */
export const getStarSign = (month, day) => {
  const bounds = [
    [1, 20, 'aquarius'],
    [2, 19, 'pisces'],
    [3, 21, 'aries'],
    [4, 20, 'taurus'],
    [5, 21, 'gemini'],
    [6, 22, 'cancer'],
    [7, 23, 'leo'],
    [8, 23, 'virgo'],
    [9, 23, 'libra'],
    [10, 23, 'scorpio'],
    [11, 23, 'sagittarius'],
    [12, 22, 'capricorn'],
  ];
  let sign = 'capricorn';
  for (const [m, d, s] of bounds) {
    if (month > m || (month === m && day >= d)) sign = s;
  }
  return sign;
};

/** 세대 라벨 — 출생 연도 10년 단위 (1970~2020 클램프) */
export const getEraLabel = (year) => {
  const decade = Math.floor(year / 10) * 10;
  return `${Math.min(Math.max(decade, 1970), 2020)}s`;
};

/** 인접 세대 — 가까운 순 */
export const getAdjacentEras = (era) => {
  const i = ERA_ORDER.indexOf(era);
  const result = [];
  for (let d = 1; d < ERA_ORDER.length; d++) {
    if (i - d >= 0) result.push(ERA_ORDER[i - d]);
    if (i + d < ERA_ORDER.length) result.push(ERA_ORDER[i + d]);
  }
  return result;
};
